import React, {useState} from 'react';
import {Link} from 'react-router';
import PreFormInfo from "./PreFormInfo";
import PassengerConfirmationForm from "./PassengerConfirmationForm";
import { Trans, useLingui } from '@lingui/react/macro';

function PreForm(props) {
    const name = `${props.passenger.firstName} ${props.passenger.lastName}`;
    const [userConfirmed, setUserConfirmed] = useState(null);
    const [userHasPermission, setUserHasPermission] = useState(null);
    const {i18n, t} = useLingui();


    if(!props.passenger?.passengerId) {
        return null;
    }


    if(userConfirmed || userHasPermission) {
        return (
            <PreFormInfo
                passengerId={props.passenger.passengerId} bookingType={props.bookingType}
                isMedicalMobilityPage={props.isMedicalMobilityPage}
            />
        )
    }

    if(userConfirmed === null && props.passenger.type === "Adult") {
        return (
            <PassengerConfirmationForm
                label={i18n._({
                    id: "are_you_pax_name",
                    message: 'Are you {name}?',
                    values: {name}
                })}
                onSubmit={setUserConfirmed}
            />
        );
    }

    if(userHasPermission === null) {
        return (
            <PassengerConfirmationForm
                label={i18n._({
                    id: "do_you_have_permission_from_pax",
                    message: 'Do you have permission from {name} to provide information on their behalf?',
                    values: {name}
                })}
                onSubmit={setUserHasPermission}
            />
        );
    }


    return (
        <div className="text-lg text-grey-darker mt-6">
            <p>
                <Trans id="please_obtain_permission_from_pax">Please obtain permission from {name} to provide information on their behalf.</Trans>
            </p>
            <div className="mt-6">
                <Link to={t({id: "/precruise/passengers"}) + `${props.isMedicalMobilityPage ? "/medicalAndMobility" : ""}`} className="inline-block mb-8 xl:mb-12 w-mobile action-button action-button-enabled">
                    <Trans id="back_to_pax_list">Back to passengers list</Trans>
                </Link>
            </div>
        </div>
    );
}

export default PreForm;